import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPaperclipIconSecondary from './svgs/PaperclipIconSecondary.js';
import SvgPaperclipIcon from './svgs/PaperclipIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var paperclipIcon = (props => useIcon(SvgPaperclipIcon, SvgPaperclipIconSecondary, props));

export { paperclipIcon as default };
